import { define } from '../../define.js';
import { DropdownItem } from './dropdown-item.js';
export * from './dropdown-item.js';
define('dropdown-item', DropdownItem);
